<!-- TODO:
This component must be separated into two components:
1. EmailVerificationDialog
2. AddEmailDialog

The first component is used to verify the email address.
The second component is used to add an email address.

This is a temporary solution to avoid breaking changes.

@Author: Hamza Ammar
@Date: 2025-04-19
 -->

<template>
  <BaseDialog
    :showCondition="emailVerificationDialogState.show"
    :persistentCondition="emailVerificationDialogState.persistent"
    @closed="changeEmailVerificationDialogState(false)"
  >
    <template v-slot:title>
      <span v-if="hasEmail" class="primary--text"> تأكيد الحساب </span>
      <span v-else class="primary--text">البريد الإلكتروني مطلوب</span>
    </template>

    <template v-slot:body>
      <template v-if="hasEmail">
        <v-form ref="form">
          <v-container fluid>
            <v-row no-gutters justify="center">
              <v-col align="center" cols="12" sm="9">
                <p>
                  لقد قمنا بإرسال رمز التحقق إلى بريدك الالكتروني<br />
                  <span class="secondary--text">{{ email }}</span
                  ><br />
                  يرجى التحقق من صندوق الرسائل الواردة أو (Spam)، وإدخال
                </p>
                <v-otp-input
                  class="ltr"
                  :rules="[requiredRule, codeRule]"
                  v-model="code"
                  length="6"
                ></v-otp-input>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>
      <template v-else>
        <v-container>
          <v-row justify="center">
            <v-col align="center" cols="12" sm="9">
              <p>
                يجب عليك إضافة بريد إلكتروني للاستمرار، هل تريد
                الانتقال إلى صفحة الملف الشخصي لإضافة البريد الإلكتروني؟
              </p>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </template>

    <template v-slot:actions>
      <template v-if="hasEmail">
        <v-row justify="center">
          <v-col align="center">
            <v-row justify="center" no-gutters>
              <v-col cols="auto">
                <v-btn @click="verify()" class="accent rounded-pill px-10">
                  تأكيد الحساب
                </v-btn>
              </v-col>
              <v-col cols="auto" v-if="emailVerificationDialogState.persistent">
                <v-btn
                  text
                  outlined
                  rounded
                  @click="cancelAndRedirectToHome()"
                  class="primary--text mr-2 mt-2 mt-sm-0"
                >
                  العودة للصفحة الرئيسية
                </v-btn>
              </v-col>
            </v-row>

            <div class="mt-5">
              <v-btn text @click="resendVerificationCode()">
                لم يصلك رمز التأكيد؟
                <span class="accent--text text-decoration-underline">
                  إعادة إرسال الرمز
                </span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row justify="center">
          <v-col align="center">
            <v-btn @click="goToProfile" class="accent rounded-pill px-10">
              الذهاب إلى الملف الشخصي
            </v-btn>

            <div class="mt-5">
              <v-btn text @click="goToHome">
                <span class="accent--text text-decoration-underline">
                  العودة للصفحة الرئيسية
                </span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/core/base/dialogs/BaseDialog.vue";
import { mapState, mapActions } from "pinia";
import { useAuthStore } from "../store/AuthStore";
export default {
  data() {
    return {
      code: "",
    };
  },
  components: { BaseDialog },
  computed: {
    ...mapState(useAuthStore, ["emailVerificationDialogState", "email"]),
    hasEmail() {
      return (
        this.email !== null &&
        this.email !== undefined &&
        this.email !== "" &&
        this.email !== "undefined" &&
        this.email !== "null"
      );
    },
  },
  methods: {
    ...mapActions(useAuthStore, [
      "changeEmailVerificationDialogState",
      "verifyEmail",
      "resendVerificationCode",
    ]),
    verify() {
      if (this.$refs.form.validate()) {
        var data = { token: this.code };
        this.verifyEmail(data)
          .then(() => {
            this.$router.go();
          })
          .catch((err) => console.err(err));
      }
    },
    goToProfile() {
      this.changeEmailVerificationDialogState(false);
      this.$router.push("/profile");
    },
    goToHome() {
      this.changeEmailVerificationDialogState(false);
      this.$router.push("/");
    },
    cancelAndRedirectToHome() {
      this.changeEmailVerificationDialogState(false);
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.ltr {
  direction: ltr !important;
}
</style>
